import React, { useState } from 'react';

const DemoVideo = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-12">
            {/* Texto */}
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold mb-6 text-[#03ADED]">
                Mira cómo funciona
              </h2>
              <p className="text-xl mb-6 text-gray-600">
                En menos de 2 minutos descubre cómo YupiSoft puede transformar la gestión de tu negocio.
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-[#03ADED] mr-2">✓</span>
                  <span>Interfaz intuitiva y fácil de usar</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#03ADED] mr-2">✓</span>
                  <span>Configuración en minutos</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#03ADED] mr-2">✓</span>
                  <span>Soporte técnico incluido</span>
                </li>
              </ul>
            </div>

            {/* Imagen con botón */}
            <div className="md:w-1/2">
              <div
                className="relative aspect-video rounded-2xl overflow-hidden shadow-xl cursor-pointer group"
                onClick={() => setIsOpen(true)}
                style={{
                  backgroundImage: `url('/4.png')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="bg-white/30 backdrop-blur-md rounded-full p-5 hover:scale-110 transition-transform">
                    <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M6.3 2.841A1.5 1.5 0 004 4.11v11.78a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="relative w-full max-w-4xl p-4">
            <div className="aspect-video bg-black rounded-lg overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/1_sF5cJbv7U?si=9A9_Fe8P7OdyRTuq"
                title="Demo YupiSoft"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <button
              className="absolute top-2 right-2 text-white text-3xl"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DemoVideo;
